import styled from 'styled-components';
import { breakpoints, css } from '../../styles/theme';
import StockModelListTemplate from './StockModelListTemplate';
import { rem } from 'polished';
import { BRAND_DS, BRAND_TYPE, isMarketIT } from 'src/constants/main';

export const LastItemBannerContainer = styled.div<{ brand: BRAND_TYPE }>`
    display: flex;
    max-width: ${rem('392px')} !important;
    width: 100% !important;
    flex-direction: column;
    justify-content: space-between;
    align-items: center;
    background: ${({ theme }) => theme.colors.white};
    border: 1px solid
        ${(prop) => (prop.brand === BRAND_DS ? prop.theme.colors.grey16 : prop.theme.colors.primaryDisabled)};
    border-radius: ${(prop) => (prop.brand === BRAND_DS ? rem(16) : 0)};
    margin: unset !important;

    .last-item-wrapper {
        width: 100%;
        display: flex;
        justify-content: center;
        flex-direction: column;
        align-items: center;

        .last-item-banner-container-text {
            width: 100%;
            max-width: ${rem('350px')};
            margin-left: auto;
            margin-right: auto;
            margin-top: 24px;
            margin-bottom: 24px;
            h3 {
                font-size: ${rem('14px')};
                text-transform: uppercase;
                line-height: ${rem('18.86px')};
            }
        }

        .last-item-banner-container-button {
            width: 100%;
            max-width: ${rem('350px')};
            button {
                transition: all 0.3s ease;
                background-color: ${({ theme }) => theme.colors.primary};
                border: none;
                color: ${({ theme }) => theme.colors.white};
                padding: ${rem('15px')};
                cursor: pointer;
                height: fit-content;
                min-width: ${rem('130px')};
                width: 100%;
                font-size: ${rem('10px')};
                text-transform: uppercase;

                &:hover {
                    background-color: ${({ theme }) => theme.colors.primaryHover};
                }

                ::-moz-focus-inner,
                :active,
                :focus-visible {
                    border: 0;
                    outline: none;
                    -moz-outline-style: none;
                    outline-style: none;
                }

                &.stock-model-card-button-disabled {
                    background: ${({ theme }) => theme.colors.grey3};
                    color: ${({ theme }) => theme.colors.white};
                    cursor: wait;
                }
            }
        }
    }

    .last-item-banner-container-image {
        background: url('/public/images/lastItemBanner.png');
        ${({ brand }) =>
            css`
                ${(brand === 'AC' || brand === 'AP') &&
                isMarketIT &&
                'background: url("/public/images/lastItemBannerIT.png");'};
            `}
        background-position: bottom center;
        background-size: contain;
        background-repeat: no-repeat;
        height: 100%;
        min-height: ${rem('565px')};
        width: 100%;
    }
`;

export const StockModelListStyled = styled(StockModelListTemplate)`
    max-width: ${rem('1250px')};
    margin: ${rem('20px')} auto;
    width: 100%;

    .model-page-wrapper {
        @media (max-width: calc(${breakpoints.xs}px - 0.1px)) {
            margin-left: 0;
            margin-right: 0;
            overflow: hidden;
        }
    }

    .grid {
        display: grid;
        width: 100%;
        gap: 25px;
        justify-items: center;
        grid-template-columns: repeat(auto-fill, 350px);
        justify-content: center;

        @media (max-width: ${breakpoints.sm}px) {
            & > div {
                max-width: 90%;
            }
        }
    }

    .showMore {
        display: flex;
        justify-content: center;

        &--btn {
            max-width: ${rem('250px')};
            margin-top: ${rem('25px')};
        }
    }
`;
